import React, { SVGProps } from 'react';
import { ReactComponent as DeleteIconSvg } from '@images/common/trash-icon.svg';

export const DeleteIcon = ({ style }: SVGProps) => {
  return <DeleteIconSvg style={style} id='delete-icon-id' className='delete-icon' />;
};
